// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from "./store"
import Meta from "vue-meta"
import http from "@/utils/http.js"
import url from "@/utils/url.js"
import common from './utils/common.js'
import ElementUI from 'element-ui';
import enLocale from 'element-ui/lib/locale/lang/en'
import 'element-ui/lib/theme-chalk/index.css';
import "./assets/css/global.css"
import 'font-awesome/css/font-awesome.min.css'

Vue.use(ElementUI, { enLocale });
Vue.prototype.$http= http;
Vue.prototype.$url= url;
Vue.prototype.$common= common;
Vue.config.productionTip = false

// Vue.use(Meta);

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    metaInfo() {
        return {
            title: this.$store.state.metaInfo.title,
            meta: [
                {
                    name: "keywords",
                    content: this.$store.state.metaInfo.keywords
                },
                {
                    name: "description",
                    content: this.$store.state.metaInfo.description
                }
            ]
        };
    },
    components: { App },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js